var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "px-2 container",
      attrs: { "data-qa": "service_list_content" },
    },
    [
      _c(
        "h1",
        {
          staticClass: "text-h4 text--text mb-6",
          attrs: { "data-qa": "column-content-h1" },
        },
        [_vm._v("\n    Медицинские услуги\n  ")]
      ),
      _vm._v(" "),
      _c(
        _setup.isMobile ? _setup.ServiceListMobile : _setup.ServiceListDesktop,
        {
          tag: "component",
          attrs: {
            "service-groups": _setup.serviceGroups,
            "data-qa": "service_list_content_list",
          },
        }
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }